import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ReconciliationToleranceDto,
  ReconciliationToleranceListDto,
  ReconciliationToleranceFilterDto,
  CreateReconciliationToleranceRequest,
  UpdateReconciliationToleranceRequest,
} from '@/types/reconciliationTolerance.types';

export const reconciliationToleranceApi = {
  /** GET /api/v1/reconciliation-tolerances — paginated list with optional filter */
  getList: (filter?: ReconciliationToleranceFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<ReconciliationToleranceListDto>>>('/reconciliation-tolerances', {
      params: filter,
    }),

  /** GET /api/v1/reconciliation-tolerances/{id} — full tolerance record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<ReconciliationToleranceDto>>(`/reconciliation-tolerances/${id}`),

  /** POST /api/v1/reconciliation-tolerances — create a new tolerance */
  create: (data: CreateReconciliationToleranceRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/reconciliation-tolerances', data),

  /** PUT /api/v1/reconciliation-tolerances/{id} — update tolerance */
  update: (id: string, data: UpdateReconciliationToleranceRequest) =>
    apiClient.put<ApiResponse<object>>(`/reconciliation-tolerances/${id}`, data),

  /** DELETE /api/v1/reconciliation-tolerances/{id} — soft-delete */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/reconciliation-tolerances/${id}`),
};
